// AgeVerifierModal.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';
import AgeVerifier from '../container/AgeVerifier.js';

import { ModalId } from '../resource/trackingConstants.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { getIsGoogleBot } from '../resource/getUserAgent.js';
import { unmountInitialCover } from '../resource/initialCover.js';

const isGoogleBot = getIsGoogleBot();

export const AgeVerifierModal = ({
  isAuthed = false,
  isModalDisplayed = false,
  isRemoteConfigMerged = false,
  shouldShowLanding = false,
  shouldShowAgeVerifier = false,
  openModal = NULL_FUNCTION,
  closeModal = NULL_FUNCTION,
}) => {
  useEffect(() => {
    if (!isRemoteConfigMerged) {
      return;
    }

    if (isAuthed) {
      unmountInitialCover();
      closeModal();
      return;
    }

    const shouldShow =
      !shouldShowLanding && shouldShowAgeVerifier && !isGoogleBot;

    if (shouldShow && !isModalDisplayed) {
      unmountInitialCover();
      openModal();
    } else if (!shouldShow && isModalDisplayed) {
      unmountInitialCover();
      closeModal();
    }
  }, [
    isAuthed,
    isModalDisplayed,
    isRemoteConfigMerged,
    shouldShowLanding,
    shouldShowAgeVerifier,
    closeModal,
    openModal,
  ]);

  return (
    <ModalView
      id="AgeVerifierModal"
      modalId={ModalId.Landing.ModalOver18}
      render={() => <AgeVerifier />}
    />
  );
};

AgeVerifierModal.propTypes = {
  isAuthed: PropTypes.bool,
  isModalDisplayed: PropTypes.bool,
  shouldShowLanding: PropTypes.bool,
  shouldShowAgeVerifier: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
};

export default AgeVerifierModal;
